import { render, staticRenderFns } from "./FireCauseVehicleThirdPartyContactQuestion.vue?vue&type=template&id=658614f2"
import script from "./FireCauseVehicleThirdPartyContactQuestion.vue?vue&type=script&lang=ts"
export * from "./FireCauseVehicleThirdPartyContactQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports